/**
 * Reads the parameters of an account confirmation / password reset link.
 *
 * Those links used to be built server-side from a route template, where '=' and '&' are literal
 * text inside a path segment : they reached the browser percent-encoded
 * (?userid%3D<id>%26token%3D<token>), and query-string parsed the whole thing as a single key.
 * The API now emits plain separators, but links already sent keep the old shape for 24h and some
 * mail gateways rewrite URLs on their own, so both forms must keep working.
 *
 * Normalising the two separators is safe here : both values are URL-safe by construction (a GUID
 * and a base64url token), neither can legitimately contain a percent sign.
 */

const safeDecode = (value) => {
  try {
    return decodeURIComponent(value)
  } catch (e) {
    // A stray '%' would make decodeURIComponent throw ; keep the raw value and let the caller
    // report an unusable link rather than crashing the submit handler.
    return value
  }
}

export const parseLinkParams = (search) =>
  String(search || '')
    .replace(/^\?/, '')
    .replace(/%3D/gi, '=')
    .replace(/%26/gi, '&')
    .split('&')
    .reduce((params, pair) => {
      const separator = pair.indexOf('=')
      if (separator > 0) params[pair.slice(0, separator)] = safeDecode(pair.slice(separator + 1))
      return params
    }, {})

export default parseLinkParams
